// extracted by mini-css-extract-plugin
export default {"description":"ForStudents_description__saYIE","container":"ForStudents_container__r+-jJ"};